import { Box, Typography } from "@mui/material";
import OrderRowCounter from "../../OrderRowCounter";
import { useAppSelector } from "../../../../app/hooks";

type Props = {
  templateName: string;
  workLocationName: string;
  workStartEnd: string;
  amount: number;
  selectRow: () => void;
  isSelected: boolean;
};

export const RowCard = ({
  templateName,
  workLocationName,
  workStartEnd,
  amount,
  selectRow,
  isSelected,
}: Props) => {
  const { workTitle } = useAppSelector((state) => state.localized);

  return (
    <Box
      sx={{
        backgroundColor: isSelected ? "#EAEAF1" : "none",
        border: isSelected ? "none" : "1px solid #EAEAF1",
        padding: `${isSelected ? "16px" : "15px"} 16px`,
        borderRadius: "8px",
        height: "auto",
        display: "flex",
        alignItems: "center",
        marginBottom: "1rem",
        justifyContent: "space-between",
        cursor: "pointer",
      }}
      onClick={selectRow}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography fontWeight={700} paddingRight={2}>
          {templateName && workTitle[templateName]}
        </Typography>
        <Typography variant="secondary">{workLocationName}</Typography>
        <Typography variant="secondary">{workStartEnd}</Typography>
      </Box>
      <Box pr={2}>
        <OrderRowCounter
          size={34}
          orderRowCount={amount}
          sx={{
            boxSxProps: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "28px",
              height: "28px",
              backgroundColor: "#EAEAF1",
              borderRadius: "100%",
            },
            textSxProps: {
              fontSize: "16px",
              fontWeight: 700,
            },
          }}
        />
      </Box>
    </Box>
  );
};
